/**
 * `<stock-counter>` custom element (v1.2).
 *
 * The Liquid renders the state for the initial variant; this element only
 * follows variant changes (`shopify:product:select`) using the real
 * quantities the block embedded as JSON. Above the threshold, untracked or
 * at zero it stays hidden — the honest rule lives in one place, here and
 * in the Liquid guard.
 */
class StockCounter extends HTMLElement {
  connectedCallback() {
    this.status = this.querySelector('[role="status"]');
    const map = this.querySelector('[data-stock-map]');
    if (!this.status || !map) return;
    try {
      this.data = JSON.parse(map.textContent);
    } catch (error) {
      return;
    }
    this.threshold = Number(this.dataset.threshold) || 5;

    document.addEventListener('shopify:product:select', (event) => {
      // Il payload sta sull'evento, non in `event.detail` (AD-29).
      const id = event.variant ? String(event.variant.id) : null;
      if (!id || !(id in this.data.levels)) return;
      const qty = this.data.levels[id];
      const show = qty > 0 && qty <= this.threshold;
      this.hidden = !show;
      this.status.textContent = show ? this.data.message.replace('__N__', String(qty)) : '';
    });
  }
}

if (!customElements.get('stock-counter')) {
  customElements.define('stock-counter', StockCounter);
}
